export default __webpack_public_path__ + "static/media/UNIVISION.15299abb.png";